<template>
  <div class="question">
    <Field
      class="inputf"
      v-model="message"
      rows="2"
      autosize
      type="textarea"
      maxlength="100"
      placeholder="请输入留言"
      show-word-limit
    />
    <div class="upfile">
      <div class="deleimg" v-for="(item, index) in fileList" :key="item">
        <img :src="item" @click="shows(item)">
        <div class="deleX" @click="delImgs(index)">X</div>
      </div>
      <Uploader :after-read="afterRead" v-if="imgid.length < 3" />
    </div>
    <div class="que-but">
      <div class="butt" @click="askQue">提交</div>
    </div>
    <div class="talk-list">
      <div class="tals-evecho" v-for="item in list" :key="item.id">
        <div class="talk-eve">
          <div class="talk-portrait" v-if="item.suid != id">
            <img :src="fabu" class="head-portrait" alt="">
          </div>
          <div class="talk-ri">
            <div class="talk-time">{{item.create_time}}</div>
            <div>{{item.content}}</div>
          </div>
          <div class="talk-portrait " v-if="item.suid == id">
            <img :src="avatarurl" class="head-portrait" alt="">
          </div>
        </div>
        <img class="quesShow" :src="items" v-for="items in item.files" @click="shows(item.files)" :key="items + 's'" alt="">
        <!-- <div  v-for="items in item.files" :key="items + 'ds'">{{items}}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Toast, Uploader, ImagePreview } from 'vant'
import { askTaskQuestion, getTaskQuestions, upQuestionImg } from '@/api/api/task'
import { getUserInfo } from '@/api/api/user'
const defaultAvatar = require('@/assets/image/head.jpg')

export default {
  data() {
    return {
      message: '',
      task_id : null,
      list: [],
      id: null,
      page: 1,
      get: true,
      no: false,
      avatarurl: defaultAvatar,
      fabu: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=2179871579,1304935257&fm=26&gp=0.jpg',
      imgid: [], // 图片id
      fileList: [] // 图片地址
    }
  },
  components: {
    Field,
    Uploader
  },
  created() {
    this.task_id = this.$route.query.task_id
    this.getQue(this.task_id)
    getUserInfo().then(res => {
      if(res.data.errorCode == '0') {
        this.id = res.data.data.id
        console.log(res.data.data.id)
        if(res.data.data.avatarurl) {
          this.avatarurl = res.data.data.avatarurl
        }
      }
    })
  },
  mounted() {
    window.addEventListener('scroll', this.onSrcoll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onSrcoll)
  },
  methods: {
    shows(x) {
      // 放大图片
      ImagePreview({
        images: [x],
        showIndex: false
      })
    },
    delImgs(num) {
      this.imgid.splice(num,1)
      this.fileList.splice(num,1)
    },
    afterRead(file) {
      const form = new FormData()
      form.append('images', file.file, file.file.name)
      console.log(form)
      upQuestionImg(form).then(res => {
        if (res.data.errorCode === 0) {
          console.log(res.data.data.success)
          this.fileList.push(res.data.data.success[0].path)
          this.imgid.push(res.data.data.success[0].file_id)
        }
      })
    },
    askQue() {
      askTaskQuestion(this.task_id, this.message, this.imgid).then(res => {
        if(res.data.errorCode === 0) {
          this.message = ''
          this.fileList = []
          this.imgid = []
          Toast({
            type: 'success',
            message: '提交成功',
            duration: 1000
          })
          this.getQues(this.task_id)
        }
      })
    },
    getQues(task_id, page) {
      getTaskQuestions(task_id, page).then(res => {
        if(res.data.errorCode == 0) {
          console.log(res.data.data.list[0], ...this.list)
          this.list = [res.data.data.list[0], ...this.list]
        }
      })
    },
    getQue(task_id, page) {
      getTaskQuestions(task_id, page).then(res => {
        if(res.data.errorCode == 0) {
          this.list = res.data.data.list
        }
      })
    },
    onSrcoll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var getWindowHeight = document.documentElement.clientHeight || document.body.clientHeight
      var documentScrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // if (document.documentElement.scrollTop + window.innerHeight === document.body.offsetHeight) {
      if (scrollTop + getWindowHeight === documentScrollHeight) {
        console.log(document.documentElement.scrollTop, window.innerHeight, document.body.offsetHeight)
        return
      }
      if (this.no) return
      if (!this.get) return

      if (scrollTop + getWindowHeight >= (documentScrollHeight - 800)) {
        this.page += 1
        this.get = false
        getTaskQuestions(this.task_id, this.page).then(res => {
          if(res.data.errorCode == 0) {
            // this.list = res.data.data.list
            this.list = [...this.list, ...res.data.data.list]
            if (Object.keys(res.data.data.list).length < 10) this.no = true
            setTimeout(() => {
              this.get = true
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.question {
  background-color: white;
  padding: 0 15px;
  padding-top: 15px;
  .upfile {
    display: flex;
    padding: 10px 0;
    .deleimg {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      position: relative;
      .deleX {
        position: absolute;
        top: 0;
        right: 0;
        width: 12px;
        height: 12px;
        background: white;
        font-size: 12px;
        text-align: center;
      }
      img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .talk-list {
    padding-top: 40px;
    .tals-evecho {
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .quesShow {
      width: 80px;
      height: 80px;
      margin-right: 12px;
      border-radius: 6px;
    }
    .talk-eve {
      display: flex;
      padding-top: 15px;
      .talk-portrait {
        margin-right: 10px;
        .head-portrait {
          width: 36px;
          height: 36px;
          border-radius: 50%;
        }
      }
      .talk-ri {
        margin-right:auto;
      }
      .talk-time {
        padding-top: 6px;
        padding-bottom: 6px;
        color: #999999;
      }
    }
  }

  .inputf {
    border: 1px solid #ccc;
    min-height: 116px;
  }
  .que-but {
    display: flex;
    justify-content: center;
    .butt {
      margin-top: 12px;
      background-color: #4464eb;
      width: 106px;
      height: 22px;
      color: white;
      line-height: 22px;
      text-align: center;
      border-radius:22px;
    }
  }
}
</style>